import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import Contextshare from './components/context/Contextshare';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 <Contextshare>
    <React.StrictMode>
    <BrowserRouter>  <App /></BrowserRouter>
    </React.StrictMode>

    
 </Contextshare>
);

